<template>
  <div class="case-view__description">
    <div class="content">
      <div class="first-half">
        <split-text :dur="1" :lazy="true">
          <div slot-scope="{}" class="block">
            <p>client</p>
            <h1>{{ client }}</h1>
          </div>
        </split-text>
        <split-text :dur="1" :lazy="true">
          <div slot-scope="{}" class="block">
            <p>deliverables</p>
            <h2>{{ deliverables }}</h2>
          </div>
        </split-text>
        <!-- <split-text :dur="1.2" :lazy="true"> -->
        <div class="cta">
          <a v-if="link" :href="link.href" target="_blank">
            {{ link.caption }}
            <svg x="0px" y="0px" viewBox="150 410 300 70" xml:space="preserve">
              <polygon
                class="st0"
                points="435.7,445.5 406.8,416.6 406.8,442.3 162.8,442.3 162.8,448.8 406.8,448.8 406.8,474.5 "
              />
            </svg>
          </a>
        </div>
        <!-- </split-text> -->
      </div>

      <div class="second-half">
        <split-text :dur="1" :lazy="true" :stay="true">
          <p slot-scope="{}">{{ description }}</p>
        </split-text>
      </div>
    </div>
  </div>
</template>

<script>
import splitText from "@/components/split-text";

export default {
  name: "Hero",
  components: { splitText },
  props: {
    client: String,
    deliverables: String,
    description: String,
    link: Object
  }
};
</script>

<style scoped lang="scss">
@import "../scss/globals.scss";
@keyframes shift {
  to {
    transform: translateX(10px);
  }
}

.case-view__description {
  display: flex;
  align-items: center;
  background-color: $color-white;
  color: $color-black;
  min-height: 50vh;
  box-sizing: border-box;
  padding: $margin1-2 $margin1-4;

  @media screen and (min-width: 768px) {
    padding: $margin1-2;
  }

  @media screen and (min-width: 1025px) {
    min-height: 75vh;
    padding: $margin2-1;
  }

  @media screen and (min-width: 1550px) {
    padding: $margin4-1;
  }

  .content {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .first-half {
    display: inline-block;
    padding-right: 4%;
    box-sizing: border-box;
    width: 100%;

    @media screen and (min-width: 769px) {
      width: 36%;
    }

    .block {
      padding-bottom: $font-size-m;

      p {
        @include typeset(trumpet);
        color: $color-grey;
      }

      h1,
      h2 {
        @include typeset(body-medium);
        @include typeface(expanded);
        color: $color-black;
        margin: 0;
      }
    }

    .cta {
      @include typeset(body-normal);
      @include typeface(expanded);

      margin: $margin1-4 0;
      color: $color-grey;
      width: fit-content;

      @media screen and (max-width: 768px) {
        margin: 0;
        margin-bottom: $font-size-m;
      }

      svg {
        transition: transform .2s;
        transform: translateZ(0);
        fill: currentColor;
        height: .8em;
        margin-bottom: -.1em;
        margin-right: 0.5em;
      }
      &:hover {
        svg {
          // animation: shift 0.3s forwards $ease-in-out;
          transform: translateX(10px);
        }
      }
    }
  }

  .second-half {
    display: inline-block;
    width: 100%;

    @media screen and (min-width: 769px) {
      width: 64%;
    }

    p {
      max-width: 55em;
      line-height: $larger-line-height;
    }
  }
}
</style>
